export default class Zahlungsbedingung {
    constructor(zbEinfach?: boolean) {
        this._zbEinfach = zbEinfach ? zbEinfach : false
    }

    _zbEinfach = false

    typ: "SKONTO" | "VERZUG" | "" | undefined
    beschreibungstext = ""

    _prozent = 0

    get prozent() {
        return this._prozent
    }

    set prozent(prozent: number) {
        this._prozent = prozent
    }

    _tage = 0

    get tage() {
        return this._tage
    }

    set tage(tage: number) {
        if (tage >= 0) {
            this._tage = tage
        } else {
            this._tage = 0
        }
    }

    // BT-20 (Einzelzeilen)
    _zahlungszeile = ""

    get zahlungszeile() {
        return this._zbEinfach ? this.zahlungszeileEinfach() : this.zahlungszeileZusammensetzen()
    }

    set zahlungszeile(zeile: string) {
        this._zahlungszeile = zeile
    }

    _basisbetrag = 0
    get basisbetrag() {
        return this._basisbetrag
    }

    set basisbetrag(betrag: number) {
        if (betrag > 0) this._basisbetrag = betrag
    }

    zahlungszeileEinfach(): string {
        return (this._zahlungszeile.trim().length > 0 && this._zahlungszeile.replaceAll("#", " ")) || ""
    }

    zahlungszeileZusammensetzen() {
        let zeile = ""
        if (this.typ && this.tage != null && this.tage >= 0 && this.prozent != null && this.prozent >= 0) {
            zeile += `#${this.typ}#TAGE=${this.tage.toFixed(0)}#PROZENT=${this.prozent.toFixed(2)}#`
            if (zeile && this.basisbetrag != 0) zeile += `BASISBETRAG=${this.basisbetrag.toFixed(2)}#`
        }
        return zeile || ""
    }

    //Backend ignoriert alle anderen Werte und parst nur die Zahlungszeile
    toJSON() {
        return {
            zahlungszeile: this.zahlungszeile,
        }
    }
}
